import angular from 'angular';
import '../../shared.module';
import template from './badge.component.html';
import './badge.component.scss';

class BadgeController {
  $onInit() {
    this.tone = this.tone || 'neutral';
  }
}

angular.module('app.shared').component('cpBadge', {
  bindings: {
    tone: '@'
  },
  controller: BadgeController,
  controllerAs: 'vm',
  transclude: true,
  template
});
